export default __webpack_public_path__ + "assets/images/aistudio/980571e6487a3b3808c97c40b5b31e0c.png";